import { enrollmentTexts } from 'consts/text';
import { AppModal, AppModalProps } from 'components/molecules';
import { CopyContentText, CopyContentTextMode } from 'components/atoms';
import { SuccessResultCheck } from 'assets';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { IconLink } from '@tabler/icons-react';

export enum EnrollmentLinkDisplayModalMode {
    DEFAULT = 'DEFAULT',
    SUCCESS = 'SUCCESS',
}

type EnrollmentLinkDisplayModalProps = Pick<AppModalProps, 'open' | 'onCancel'> & {
    link: string;
    mode: EnrollmentLinkDisplayModalMode;
};

const StyledSuccessResultCheck = styled(SuccessResultCheck)`
    && {
        height: 40px;
        width: 40px;
    }
`;

const StyledIconLink = styled(IconLink)`
    && {
        height: 40px;
        width: 40px;
    }
`;

export const EnrollmentLinkDisplayModal = ({
    link,
    mode,
    open,
    onCancel,
}: EnrollmentLinkDisplayModalProps) => {
    const isSuccessMode = mode === EnrollmentLinkDisplayModalMode.SUCCESS;

    const currentDate = dayjs();
    const currentYear = currentDate.year();

    const titleMainText = isSuccessMode
        ? enrollmentTexts.displayEnrollmentLink.success.title
        : enrollmentTexts.displayEnrollmentLink.default.title;
    const titleText = `${titleMainText} ${currentYear}`;

    return (
        <AppModal
            titleLevel={5}
            title={titleText}
            icon={isSuccessMode ? <StyledSuccessResultCheck /> : <StyledIconLink />}
            width={420}
            open={open}
            isMobileFullScreenMode={false}
            onCancel={onCancel}
        >
            <CopyContentText mode={CopyContentTextMode.BORDERED} text={link} />
        </AppModal>
    );
};
